import { useTLang } from 'intl/intl';

import makeClasses from './MultipleChoice.style';

export function MultipleChoice() {
  const lang = {
    label: useTLang({ id: 'substitutionFlow.014' }),
  };

  const _classes = makeClasses();

  return <p className={_classes.paragraph}>{lang.label}</p>;
}
